import React from "react";
import PersonalApp from "./msTeams/personalApp/PersonalApp";
import AuthProvider from "authorization/AuthProvider";
import DictionaryProvider from "dictionary/DictionaryProvider";
import ConfigProvider from "config/ConfigProvider";
import { Outlet } from "react-router-dom";
import { stores, StoreContext } from "stores/Stores";
import PowerBiReportsStore from "powerbi-reports/store";
import View360Store from "view360Card/store";
import ResizerStore from "shared/stores/resizeStore/ResizerStore";
import { history } from ".";

const App: React.FC = () => (
    <StoreContext.Provider value={stores}>
        <ResizerStore>
            <PowerBiReportsStore>
                <View360Store history={history}>
                    <PersonalApp>
                        <ConfigProvider>
                            <AuthProvider>
                                <DictionaryProvider>
                                    <Outlet />
                                </DictionaryProvider>
                            </AuthProvider>
                        </ConfigProvider>
                    </PersonalApp>
                </View360Store>
            </PowerBiReportsStore>
        </ResizerStore>
    </StoreContext.Provider>
);

export default App;
